// Add this import at the top of your file
import countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';

// Initialize the library with German language support
countries.registerLocale(de);

// In your component, before the return statement:
const countryOptions = Object.entries(countries.getNames('de')).map(([code, name]) => ({
    value: code,
    label: name
}));

// Sort alphabetically
countryOptions.sort((a, b) => a.label.localeCompare(b.label));

// Move Germany to the top as default
const germanyOption = countryOptions.find(country => country.value === 'DE');
if (germanyOption) {
    countryOptions.splice(countryOptions.indexOf(germanyOption), 1);
    countryOptions.unshift(germanyOption);
}

export default countryOptions;